import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'

import {
  INVENTORY_TRANSFER_RESET_STATE,
  INVENTORY_TRANSFER_SET_TRANSFERS,
  INVENTORY_TRANSFER_SET_TRANSFER_DETAIL,
  INVENTORY_TRANSFER_SET_OUTLETS,
  INVENTORY_TRANSFER_SET_CURRENT_PAGE,
  INVENTORY_TRANSFER_SET_TOTAL_PAGE,
  INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN,
  INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN,
  INVENTORY_TRANSFER_SET_SELECTED_OUTLETS,
  INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM,
  INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL,
  INVENTORY_TRANSFER_SET_ADD_ITEMS,
  INVENTORY_TRANSFER_RESET_ADD_ITEMS,
  INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING,
  INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL,
  INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL,
  INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED,
  INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS,
  INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS,
  INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT
} from 'actions/inventory/transfer/constants'

let initialState = {
  outlets: [],
  selectedOutlets: [],
  transfers: [],
  openRightColumn: false,
  transferDetail: null,
  currentPage: null,
  totalPage: null,
  showAddItemsModal: false,
  showConfirmSubmitModal: false,
  itemOptionIsLoading: false,
  isItemAlreadyAdded: false,
  addItems: {
    items: [],
    itemOptions: [],
    currentPage: 0,
    totalPage: 0
  },
  exportButtonStatus: true,
  confirmCreateButtonStatus: false,
  searchItemsInit: {
    items: [],
    itemOptions: [],
    currentPage: 0,
    totalPage: 0
  }
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case INVENTORY_TRANSFER_RESET_STATE:
      return {
        ...state,
        outlets: [],
        selectedOutlets: [],
        transfers: [],
        openRightColumn: false,
        transferDetail: null,
        currentPage: null,
        totalPage: null,
        showAddItemsModal: false,
        showConfirmSubmitModal: false,
        itemOptionIsLoading: false,
        isItemAlreadyAdded: false,
        addItems: {
          items: [],
          itemOptions: [],
          currentPage: 0,
          totalPage: 0
        },
        exportButtonStatus: true,
        searchItemsInit: {
          items: [],
          itemOptions: [],
          currentPage: 0,
          totalPage: 0
        }
      }
    case INVENTORY_TRANSFER_SET_TRANSFERS:
      return {...state, transfers: payload.transfers}
    case INVENTORY_TRANSFER_SET_TRANSFER_DETAIL:
      return {...state, transferDetail: payload.transfer}
    case INVENTORY_TRANSFER_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case INVENTORY_TRANSFER_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case INVENTORY_TRANSFER_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case INVENTORY_TRANSFER_SET_SELECTED_OUTLETS:
      return {...state, selectedOutlets: payload.selectedOutlets}
    case INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM:
      return {...state, showAddItemsModal: true}
    case INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL:
      return {...state, showAddItemsModal: false}
    case INVENTORY_TRANSFER_SET_ADD_ITEMS:
      return {...state, addItems: payload.addItems}
    case INVENTORY_TRANSFER_RESET_ADD_ITEMS:
      return {...state, addItems: {items: [], itemOptions: [], currentPage: 0, totalPage: 0}}
    case INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING:
      return {...state, itemOptionIsLoading: payload.itemOptionIsLoading}
    case INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL:
      return {...state, showAddItemsModal: false}
    case INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL:
      return {...state, showConfirmSubmitModal: payload.isShowConfirmSubmitModal}
    case INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED:
      return {...state, isItemAlreadyAdded: payload.isItemAlreadyAdded}
    case INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS:
      return {...state, exportButtonStatus: payload.exportButtonStatus}
    case INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS:
      return {...state, confirmCreateButtonStatus: payload.isClicked}
    case INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT:
      return {...state, searchItemsInit: payload.itemInit}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/inventory/transfer.js